import React, { useEffect, useState } from "react";
import {
	isNotificationSoundMuted,
	setNotificationSoundMuted,
} from "../../helpers/notificationSoundPreference";

function IconBell() {
	return (
		<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M10.268 21a2 2 0 0 0 3.464 0" />
			<path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
		</svg>
	);
}

function IconBellOff() {
	return (
		<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M10.268 21a2 2 0 0 0 3.464 0" />
			<path d="M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742" />
			<path d="M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05" />
			<path d="m2 2 20 20" />
		</svg>
	);
}

export default function NotificationSoundToggle({ userId }) {
	const [muted, setMuted] = useState(() => isNotificationSoundMuted(userId));

	useEffect(() => {
		setMuted(isNotificationSoundMuted(userId));
	}, [userId]);

	const label = muted ? "Ativar som das notificações" : "Silenciar notificações";

	return (
		<button
			type="button"
			title={label}
			aria-label={label}
			aria-pressed={muted}
			className="app-menu__phone"
			onClick={(e) => {
				e.stopPropagation();
				const next = !muted;
				setNotificationSoundMuted(userId, next);
				setMuted(next);
			}}
		>
			<span className="menu-icon">{muted ? <IconBellOff /> : <IconBell />}</span>
			<span className="app-menu__phone-label">
				{muted ? "Som desativado" : "Som ativado"}
			</span>
		</button>
	);
}
